// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__11Ve8","tab":"Tabs_tab__1dsaH","tabActive":"Tabs_tabActive__2mngI"};